<template>
    <v-card>
        <v-card-title>Bonificações</v-card-title>
        <v-simple-table>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">Cliente</th>
                        <th class="text-left">Módulo/Plano</th>
                        <th class="text-left">Pgto. Cliente</th>
                        <th class="text-left">Parcela</th>
                        <th class="text-left">Comissão</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in orderedItems" :key="item.id">
                        <td>{{ item.customer.trade_name }}</td>
                        <td>{{ item.product }}</td>
                        <td>
                            {{ item.period.formattedPaidAt }}
                        </td>
                        <td>
                            {{ item.readableInstallment }}
                        </td>
                        <td>{{ item.formattedValue }}</td>
                    </tr>
                    <tr>
                        <td colspan="4">
                            <strong>Total</strong>
                        </td>
                        <td>
                            <strong>{{ $n(total, 'currency') }}</strong>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </v-card>
</template>
<script>
export default {
    props: {
        items: {
            required: true,
        },
    },

    computed: {
        orderedItems() {
            if (!this.items.length) return
            const items = this.items
            return items.sort((a, b) => {
                const customerComparison = a.customer.trade_name.localeCompare(
                    b.customer.trade_name,
                )
                const productComparison = a.product.localeCompare(b.product)

                return customerComparison || productComparison
            })
        },

        total() {
            if (!this.items.length) return 0

            const total = this.items.reduce(
                (sum, item) => (sum += parseFloat(item.value)),
                0,
            )

            return total
        },
    },
}
</script>
